import React, {useEffect, useState } from "react";
//import { withRouter } from 'react-router';
import Button         from '@material-ui/core/Button';
//import Typography     from '@material-ui/core/Typography'; //2021.11.27 Typography無効化に伴い、コメントアウト
import TextField      from '@material-ui/core/TextField';
import Grid           from '@material-ui/core/Grid'
import MenuItem       from '@material-ui/core/MenuItem';
import queryString    from 'query-string'
//import {Modal}        from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import firebase       from'firebase/compat/app';
import 'firebase/compat/auth';

/**
 * 診療結果登録・更新・削除モーダル用のコンポーネント
 */
export default function ModalDiagnosis(props) {
  // URL情報から更新・削除対象のDocIdを取得
  let docId = '';
  if(window.location.search){
    docId = queryString.parse(window.location.search).data||null;
  }
  //if(this.props.location.search){
  //  docId = queryString.parse(this.props.location.search).data||null;
  //}

  /**
   * 現在日付を[MM月DD日（曜日）hh時mm分]形式で返す関数
   */
  const getDateDisplayFormat = () => {
    var now = new Date();
    return (now.getMonth()+1).toString().padStart(2, '0') + "月"
      + now.getDate().toString().padStart(2, '0') + "日（"
      + [ "日", "月", "火", "水", "木", "金", "土" ][now.getDay()] + "）"
      + now.getHours().toString().padStart(2, '0') + "時"
      + now.getMinutes().toString().padStart(2, '0') + "分"
  }

  const [ DisplayName,     setDisplayName      ] = useState(props.DisplayName) // 表示対象者の名前
  const [ MedicalRecordId, setMedicalRecordId  ] = useState(props.MedicalRecordId) // 症状カードID
  const [ ResultId,        setResultId         ] = useState(docId)                                     // 診療結果ID(更新・削除用)
  const [ ConsultationTime,setConsultationTime ] = useState(getDateDisplayFormat())               // 受診時刻(自動入力)
  const [ HospitalName,    setHospitalName     ] = useState('') //病院名
  const [ MedicalSpecialty,setMedicalSpecialty ] = useState('') //診療科目
  const [ DoctorName,      setDoctorName       ] = useState('') //先生の名前
  const [ Diagnosis,       setDiagnosis        ] = useState('') //診断結果
  const [ Instructions,    setInstructions     ] = useState('') //医者の指示
  const [ Note,            setNote             ] = useState('') //メモ
  const [ CreateTime,      setCreateTime       ] = useState('') //作成日時
  const [ UpdateTime,      setUpdateTime       ] = useState('') //更新日時

  /**
   * 画面上に表示される各要素の選択肢一覧
   * (下記の設定を変更すれば、render()部の修正は不要)
   */
  const choicesMap = {
    MedicalSpecialty: [ // 診療科目
      "内科",
      "外科",
      "小児科",
      "呼吸器科",
      "消化器科",
      "循環器科",
      "眼科",
      "耳鼻咽喉科",
      "皮膚科"],
    Diagnosis: [ // 診断結果
      "経過観察",
      "要治療",
      "1週間以内に再来院",
      "1ヶ月以内に再来院",
      "処方箋のみ"],
    x: ["-"]
  }

  /**
   * 登録・削除の場合、登録済みデータをfirestoreから取得
   */
  const ReadResult = async() => {

    // firestoreから現在の登録データを取得し、モーダル表示画面に反映
    if(ResultId){
      const db = firebase.firestore()

      await db.collection("MedicalRecords").doc(MedicalRecordId)
      .collection("MedicalResults").doc(ResultId)
      .get().then(function(doc) {
        if(doc.data()){
          setConsultationTime (doc.data().ConsultationTime    || '') //受診時刻
          setHospitalName     (doc.data().HospitalName        || '') //病院名
          setMedicalSpecialty (doc.data().MedicalSpecialty    || '') //診療科目
          setDoctorName       (doc.data().DoctorName          || '') //先生の名前
          setDiagnosis        (doc.data().Diagnosis           || '') //診断結果
          setInstructions     (doc.data().Instructions        || '') //医者の指示
          setNote             (doc.data().Note                || '') //メモ
          setCreateTime       (doc.data().CreateTime.toDate() || '') //作成日時
          setUpdateTime       (doc.data().UpdateTime.toDate() || '') //更新日時
        }
      })
    }
  }

  //モーダルを非表示状態に切り替える
  const handleModalClose = () => {
    if(typeof props.handleModalClose == 'function'){
      props.handleModalClose() // 症状カード画面のモーダルを閉じる
    }
  }

  //モーダルを非表示状態に切り替え、症状カード画面で再読み込みする
  const handleReloadModalClose = () => {
    if(typeof props.handleReloadModalClose == 'function'){
      props.handleReloadModalClose() // 症状カード画面のモーダルを閉じ、画面内データを再読み込みする。
    }
  }

  /**
   * 経過情報登録モーダルの各選択肢の変更を制御する関数
   * (TextFieldのname要素とstateの名前を対応付けて処理を共通化)
   * @param {*} e 各選択肢のTextField要素
   */
  //
  const handleChange = (e) => {
    eval("set" + e.target.name + "(\""+ e.target.value + "\")")
    // this.setState({
    //   [e.target.name]: e.target.value
    // })
  }

  /**
   * 現在日付を[YYYYMMDDhhmmss]形式で返す関数
   */
  const getDateIdFormat = () => {
    var now = new Date();
    return "" + now.getFullYear()
      + (now.getMonth()+1).toString().padStart(2, '0')
      + now.getDate().toString().padStart(2, '0')
      + now.getHours().toString().padStart(2, '0')
      + now.getMinutes().toString().padStart(2, '0')
      + now.getSeconds().toString().padStart(2, '0');
  }

  /**
   * 削除ボタン押下時の処理
   */
  const handleDeleteButtonClick = () => {
    // 削除実行の確認用ポップアップ
    if (!window.confirm("診断結果を削除します")) {
      alert("削除をキャンセルしました");
      // this.props.history.goBack();
      return;
    }

    deleteResult();
  }

  const deleteResult = async() => {
    let db = firebase.firestore()

    //削除処理は前画面からデータを引き継いでいる場合のみ実行可能
    if(ResultId){
      await db.collection("MedicalRecords").doc(MedicalRecordId)
      .collection("MedicalResults").doc(ResultId).delete()
      .then(()=>{
        alert("診察結果を削除しました")
      })
      .catch(function(error) {
        alert("削除に失敗しました")
        console.log("診察結果の削除に失敗しました ", error);
      });
    }
    handleReloadModalClose() //モーダル画面を閉じ、画面データの再読み込みを行う。
    //this.props.history.goBack();
  }

  /**
   * 登録ボタン押下時の処理
   */
  const handleRegistButtonClick = () => {
    registResult()
  }

  const registResult = async() => {
    let db = firebase.firestore()
    let doc_id = getDateIdFormat()

    const setData = {  // NULLチェックは右記のショートハンドで実施([条件式]?[true]:[false] → ||)
      // BodyTemperature:  BodyTemperature  || '', //体温（数値型）
      ConsultationTime: ConsultationTime || '', //受診時刻
      CreateTime:       CreateTime       || firebase.firestore.FieldValue.serverTimestamp(),  //作製時刻（firebaseのサーバー時刻）
      // DeleteFlag: false, //削除フラグ
      Diagnosis:        Diagnosis        || '', //診断結果
      DoctorName:       DoctorName       || '', //先生の名前
      HospitalName:     HospitalName     || '', //病院名
      Instructions:     Instructions     || '', //医者の指示
      MedicalSpecialty: MedicalSpecialty || '', //診療科目
      Note:             Note             || '', //メモ
      UpdateTime:       firebase.firestore.FieldValue.serverTimestamp(), //作製時刻（firebaseのサーバー時刻）
    }

    if(ResultId){ //更新時
      await db.collection("MedicalRecords").doc(MedicalRecordId)
      .collection("MedicalResults").doc(ResultId)
      .set(setData)
      .then((result)=>{
        alert("診察結果を更新しました")
        doc_id = ResultId
        //this.props.history.goBack();
        handleReloadModalClose() //モーダル画面を閉じ、画面データの再読み込みを行う。
    })
      .catch(function(error) {
        alert("更新に失敗しました")
        console.log("診察結果の更新に失敗しました ", error);
      });
    }
    else{ //新規登録時
      await db.collection("MedicalRecords").doc(MedicalRecordId)
      .collection("MedicalResults").doc(doc_id)
      .set(setData).then((result)=>{
          alert("診察結果を登録しました")
          //this.props.history.goBack();
          handleReloadModalClose() //モーダル画面を閉じ、画面データの再読み込みを行う。
      })
      .catch(function(error) {
        alert("登録に失敗しました")
        console.log("診察結果の登録に失敗しました ", error);
      });
    }
  }

  useEffect(() => { //ページ表示時、情報更新時に実行
    // componentDidMount のタイミングで実行したい処理を記述
    console.log("useEffect: ReadResult")
    ReadResult()
    // 次の行のコメントでeslintの余分なワーニングを抑制する。
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => { //ページを離れる際に実行
    // componentDidMount のタイミングで実行したい処理を記述
    return () => {
      // componentWillUnmount のタイミングで実行したい処理を記述
      document.title = 'ふぁみかるくん' //家族ホーム画面を離れる際、ページタイトルを初期値に戻す
    }
  }, [])


  return (
    <React.Fragment>
      <Grid container direction="row" justifyContent="flex-start" alignItems="flex-end" spacing={2}>
        <Grid item xs={12}>
          診察：先生に言われたことを残しておきましょう
        </Grid>
        <Grid container item xs={12} justifyContent="flex-end">
          {DisplayName}
        </Grid>
        <Grid item xs={12}>
          <TextField fullWidth required id="ConsultationTime" label="受診日時" name="ConsultationTime" value={ConsultationTime} onChange={(e)=>handleChange(e)}/>
        </Grid>
      
        <Grid item xs={12}>
          <TextField fullWidth id="inputHospitalName" label="受診医療機関" name="HospitalName" value={HospitalName} onChange={(e)=>handleChange(e)}/>
        </Grid>
        <Grid item xs={12}>
          <TextField select fullWidth id="selMedicalSpecialty" label="診療科" name="MedicalSpecialty" value={MedicalSpecialty} onChange={(e)=>handleChange(e)}>
            {choicesMap.MedicalSpecialty.map(item => <MenuItem key={item} value={item}>{item}</MenuItem>)}
          </TextField>
        </Grid>
        <Grid item xs={12}>
          <TextField fullWidth id="inputDoctorName" label="先生の名前" name="DoctorName" value={DoctorName} onChange={(e)=>handleChange(e)}/>
        </Grid>
        <Grid item xs={12}>
          <TextField fullWidth id="selDiagnosis" label="診察結果" name="Diagnosis" value={Diagnosis} onChange={(e)=>handleChange(e)}/>
          {/* <TextField select fullWidth id="selDiagnosis" label="診察結果" name="Diagnosis" value={Diagnosis} onChange={(e)=>handleChange(e)}>
            {choicesMap.Diagnosis.map(item => <MenuItem key={item} value={item}>{item}</MenuItem>)}
          </TextField> */}
        </Grid>
        <Grid item xs={12}>
          <TextField fullWidth id="inputInstructions" label="先生からの指示" name="Instructions" value={Instructions} onChange={(e)=>handleChange(e)}/>
        </Grid>

        <Grid item xs={12}>
          <TextField fullWidth id="inputNote" label="メモ" name="Note" value={Note} onChange={(e)=>handleChange(e)}/>
        </Grid>
      </Grid>
      <p> </p>
      <Grid container justifyContent="space-between" alignItems="flex-start">
        <div style={{display: (ResultId ? 'block' : 'none')}}> {/* 診断情報が登録済みの場合のみ削除ボタンを表示する */}
          <Button variant="outlined" color="secondary" onClick={()=>handleDeleteButtonClick()}>削除</Button>
        </div>
        <Button variant="outlined" color="primary" onClick={()=>handleModalClose()}>キャンセル</Button>
        <Button variant="outlined" color="primary" onClick={()=>handleRegistButtonClick()}>登録</Button>
      </Grid>
    </React.Fragment>
  );
}
